<template>
  <div
    class="checkbox-container h-fit w-fit rounded-full p-3 hover:bg-neutral-200"
    :class="{
      'cursor-pointer': !disabled,
      'pointer-events-none cursor-not-allowed': disabled,
    }"
    @click.stop="
      () => {
        if (disabled) {
          return;
        }
        model = !model;
      }
    "
  >
    <input
      v-model="model"
      type="checkbox"
      :disabled="disabled"
      :indeterminate="indeterminate"
    />
  </div>
</template>

<script setup lang="ts">
const model = defineModel<boolean>();

withDefaults(
  defineProps<{
    disabled?: boolean;
    indeterminate?: boolean;
  }>(),
  { disabled: false, indeterminate: false },
);
</script>
<style scoped>
/* https://moderncss.dev/pure-css-custom-checkbox-style/ */
input[type='checkbox'] {
  border-color: var(--color-primary-300);
  background-color: var(--color-neutral-50);
  color: var(--color-primary-300);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  box-shadow:
    var(--tw-ring-offset-shadow),
    var(--tw-ring-shadow),
    0 0 #0000;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  appearance: none;
  margin: 0;

  font: inherit;
  width: 1.15em;
  height: 1.15em;
  border: 0.15em solid;
  border-radius: 0.15em;
  margin-top: -0.075em;
  cursor: pointer;
  display: grid;
  place-content: center;
}

.checkbox-container:hover > input[type='checkbox'] {
  border-color: var(--color-primary-500);
  background-color: var(--color-neutral-50);
}

/* checked styles */
input[type='checkbox']:checked {
  border-color: var(--color-primary-500);
  background-color: var(--color-neutral-50);
}

input[type='checkbox']:checked::before {
  background-color: var(--color-primary-500);
  color: var(--color-primary-500);
  content: '';
  width: 0.65em;
  height: 0.65em;
  background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="%237D26C9"><path d="M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2.5-2.5a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z"/></svg>')
    no-repeat center center;
}

input[type='checkbox']:checked:hover {
  border-color: var(--color-primary-500);
  background-color: var(--color-neutral-50);
}

input[type='checkbox']:checked:focus {
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  box-shadow:
    var(--tw-ring-offset-shadow),
    var(--tw-ring-shadow),
    0 0 #0000;
  outline: none;
}

/* disabled styles */
input[type='checkbox']:disabled {
  border-color: var(--color-neutral-500);
  cursor: not-allowed;
}

input[type='checkbox']:disabled:checked:hover {
  border-color: var(--color-neutral-500);
  cursor: not-allowed;
}

input[type='checkbox']:checked:disabled::before {
  background-color: var(--color-neutral-500);
  cursor: not-allowed;
}

/* indeterminate styles */

.checkbox-container:hover > input[type='checkbox']:indeterminate,
input[type='checkbox']:indeterminate {
  background-color: var(--color-primary-500);
  color: var(--color-primary-500);
}

input[type='checkbox']:disabled:indeterminate {
  background-color: var(--color-neutral-500);
}
</style>
